import React, { useEffect, useState } from "react";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import "../../assets/scss/pages/mylearning.scss";
import { FaAngleDown, FaChevronLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import CourseSlider from "../../components/CourseSlider";
import ApiService from "../../services/ApiService";

import SubscribedCourseCard from "../../components/SubscribedCourseCard";
import Loader from "../../features/Loader";
import { useDispatch, useSelector } from "react-redux";
import { fetchSubscribedCourse } from "../../store2/features/subscribedCourseSlice";

// Helper: returns true if the given expiryDate string is in the past
const isCourseExpired = (expiryDate) => {
  if (!expiryDate) return false;
  return new Date(expiryDate) < new Date();
};

export default function MyLearning() {
  // =============Breadcrumb Path======
  const path = [
    { text: "Home", path: "/" },
    { text: "Dashboard" }, // No path for the active page
  ];

  const [Course, setCourse] = useState([]);
  const [userDetails, setUserDetails] = useState(false);
  const [loaderStatus, setLoaderStatus] = useState(true);

  const dispatch = useDispatch();
  const courses = useSelector((state) => state.subscribedCourses.items);
  const loading = useSelector((state) => state.subscribedCourses.loading);

  useEffect(() => {
    dispatch(fetchSubscribedCourse());
  }, [dispatch]);

  // useEffect(() => {
  //   console.log("----------------Courses from slice--------------------", courses)
  // }, [courses]);
  useEffect(() => {}, [courses]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ApiService.publicGetRequest(
          "/courses/findallcourses"
        );
        setLoaderStatus(false);
        setCourse(response.data.data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (window.location.toString().includes("user")) {
      let userDetailss = localStorage.getItem("userDetails");
      if (userDetailss) {
        setUserDetails(JSON.parse(userDetailss));
      }
    }
  }, []);

  let settings = {
    dots: false,
    lazyLoad: true,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    prevArrow: (
      <button type="button" className="slick-prev">
        <FaChevronLeft />
      </button>
    ),
    nextArrow: (
      <button type="button" className="slick-next">
        <FaChevronRight />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [visibleItems, setVisibleItems] = useState(4); // State to track the number of visible items

  // const loadMoreItems = () => {
  //   setVisibleItems(prevVisibleItems => prevVisibleItems + 4); // Increase the number of visible items by 6
  // };

  useEffect(() => {
    document.title = "My Learnings";
  }, []);

  return (
    <>
      <div className="sectionWrapper pb-1">
        <Container>
          {/* ============Breadcrumb ======= */}
          {/* <Breadcrumb path={path} /> */}
          {/* ============Breadcrumb ======= */}
          {/* <SectionHeader className="">
            <span className="subtitle">Welcome back {userDetails.username}</span>
            <h2 className="title">
              Your <span>Courses</span>
            </h2>
          </SectionHeader> */}

          <div className="sectionheader pb-1">
            <h2 className="title">
              My <span>Learning</span>
            </h2>
          </div>

          <Row>
            {loading ? (
              <Loader />
            ) : courses && courses.length > 0 ? (
              courses.map((course, index) => (
                <Col md={3} key={index}>
                  {/* ── Expired Badge ───────────────────────────────── */}
                  {isCourseExpired(course.expiryDate) && (
                    <div
                      className="alert alert-danger d-flex align-items-center gap-2 mb-1 py-2 px-3"
                      role="alert"
                      style={{ borderRadius: "8px", fontWeight: 500, fontSize: "0.85rem" }}
                    >
                      <span>⚠️</span>
                      <strong>Course Expired</strong>
                    </div>
                  )}
                  {/* ─────────────────────────────────────────────────── */}
                  <SubscribedCourseCard course={course.course} />
                </Col>
              ))
            ) : (
              <div className="alert alert-info d-flex justify-content-center align-items-center">
                <h2 className="fw-bold">No course yet</h2>
              </div>
            )}
            {
              // (Course.length > 0 && Course.slice(0, visibleItems).map((course, index) => (
              // (Course.map((course, index) => (
              //   <Col md={3} key={index}>
              //     <SubscribedCourseCard course={course} />
              //   </Col>
              // )))
              /* {visibleItems < Course.length && (
              <div className=" row   ">
                <div className="offset-md-4 col-md-4 text-center   ">
                  <button className="btn btn-primary btn-lg w-100" onClick={loadMoreItems}>Show More <FaAngleDown /></button>
                </div>
              </div>
            )} */
            }
          </Row>
          {/* {!loaderStatus && <>
            <SectionHeader className="">
              <h2 className="title">
                New <span>Courses</span>
              </h2>
            </SectionHeader>
            <Courses course={Course} />
          </>} */}
        </Container>
      </div>

      {!loaderStatus && (
        <>
          <div className="sectionWrapper mylearning-wrapper">
            <Container>
              <Row>
                <Col sm={12}>
                  <div className="content-box p-3">
                    {/* <h2 className="title">Course to get your start</h2> */}

                    <div className="tabs-wrapper">
                      <Tabs
                        defaultActiveKey="recommended"
                        transition={false}
                        id="noanim-tab-example"
                        className="mb-3"
                      >
                        <Tab eventKey="recommended" title="Recommended">
                          {<CourseSlider dataCourse={Course} />}
                        </Tab>
                        <Tab eventKey="mostpopular" title="Most Popular">
                          {<CourseSlider dataCourse={Course} />}
                        </Tab>
                      </Tabs>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      )}
    </>
  );
}
